export default "__VITE_ASSET__dAPBet9h__"